import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { isAxiosError } from "axios";
import { EventCardEvent } from "features/CenterContent/RoleContent/EventHandling/components/eventCard/types";
import { PlanEventInformation } from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";

export function usePreviousEventVersion({ uuid, version }: EventCardEvent) {
  const { data, status } = useQuery({
    queryKey: ["previousEventVersion", uuid, version],
    enabled: Boolean(uuid && version),
    queryFn: async ({ signal }) => {
      const response = await axiosClient
        .get<PlanEventInformation>(
          `${getBackendUrl()}/operational-information/${uuid}/${version}/previous`,
          { signal },
        )
        .catch((err) => {
          if (isAxiosError(err) && err.status === 404) {
            return err.response;
          }
          throw err;
        });

      if (response?.status === 404) return null;
      return response?.data;
    },
    retry: false,
  });

  return { data, status };
}
